import { Modal } from "@mui/material";
import { ReactElement } from "react";

const CustomModal: React.FC<CustomModalProps> = ({
  open,
  setOpen,
  children,
  containerClassName,
}) => {
  return (
    <Modal open={open} onClose={() => setOpen(false)} className="custom-modal">
      <div className="custom-modal-container">
        <div className={` ${containerClassName}`}>{children}</div>
      </div>
    </Modal>
  );
};

export default CustomModal;

export interface CustomModalProps {
  open: boolean;
  setOpen: (o: boolean) => void;
  children: ReactElement;
  containerClassName?: string;
}
